import React from 'react';
import dashboard from '../../assets/img/dashboard-icon.png'
import mr from '../../assets/img/mr-management-selected-icon.png'
import feeder from '../../assets/img/mr-management-icon.png'
import tcaudit from '../../assets/img/tc-audit-default-icon.png'
import billing from '../../assets/img/group-4773.png'
import disconnection from '../../assets/img/disconnections-icon.png'
import settings from '../../assets/img/settings.png'

export const SidebarData = [
  {
    title: "Dashboard",
    icon: dashboard,
    link: "/dashboard"
  },
  {
    title: "MR Management",
    icon: mr,
    link: "/mr-management"
  },
  {
    title: "Feeder Management",
    icon: feeder,
    link: "/feeders"
  },
  {
    title: "Energy Audit",
    icon: tcaudit,
    link: "/tc-audit",
    hasSubmenu: true,
    isSubmenuShowing: false,
    subMenu: [
      {
        title: "TC Audit",
        link: "/tc-audit",
      },
      {
        title: "TC Details",
        link: "/tc-details",
      },
    ],
  },
  {
    title: "Billing",
    icon: billing,
    link: "/billing"
  },
  {
    title: "Disconnections",
    icon: disconnection,
    link: "/disconnections",
  },
  {
    title: "Settings",
    icon: settings,
    link: "/settings",
  }
]